import { Injectable } from '@angular/core';
import * as jose from 'jose';

export interface PubKeyConfig {
  rawPublicKey?: boolean;
}

@Injectable({
  providedIn: 'root',
})

export class CryptoService {
  private publicKey;
  private privateKey;
  constructor() {}

  public async generateKeyPairForRequest() {
    const { publicKey, privateKey } = await jose.generateKeyPair('RSA-OAEP-256', {modulusLength: 4096});
    this.publicKey = publicKey;
    this.privateKey = privateKey;
  }

  public async getPubKey(config: PubKeyConfig = {}) {
    const publicKey = await jose.exportSPKI(this.publicKey);
    return config?.rawPublicKey ? encodeURIComponent(this.modifyPublicKey(publicKey)) : publicKey;
  }

  modifyPublicKey(publicKey) {
    publicKey = publicKey.replace("-----BEGIN PUBLIC KEY-----\n", "");
    publicKey = publicKey.replace("\n-----END PUBLIC KEY-----", "");
    publicKey = publicKey.replace(/\n|\r/g, "");
    return publicKey;
  }
  /**
   * This function returns the decrypted data as plain text
   * @param data Object containing compact_encrypted_data
   */
  public async compactDecrypt(data) {
    const { plaintext, protectedHeader } = await jose.compactDecrypt(data["compact_encrypted_data"], this.privateKey);
    let decryptedData = new TextDecoder().decode(plaintext);
    return decryptedData;
  }

  public async encrypt(data: string, publicKeyPem: string): Promise<string> {
    /* We remove it if it is added to the public key. So that it is not added twice in the publicKeyPem.*/
    publicKeyPem = this.modifyPublicKey(publicKeyPem);
    publicKeyPem = `-----BEGIN PUBLIC KEY-----\n${publicKeyPem}\n-----END PUBLIC KEY-----`;

    const publicKey = await jose.importSPKI(publicKeyPem, 'RSA-OAEP-256');

    const encryptedData = await new jose.CompactEncrypt(new TextEncoder().encode(data))
      .setProtectedHeader({ alg: 'RSA-OAEP-256', enc: 'A256GCM' })
      .encrypt(publicKey);

    return encryptedData;
  }
}
